import { useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import Link from '../Atoms/Link';

import { FlyInText, OpacityWrapper } from '../Atoms/Animations';
import ArrowButton from '../Atoms/ArrowButton';

const imageQuery = graphql`
query {
  contactPerson: file(base: {eq: "contactperson.png"}) {
    childImageSharp {
      gatsbyImageData(
        width: 200,
        placeholder: DOMINANT_COLOR,
      )
    }
  }
}
`;

interface ContactProps {
  title?: string,
  wrapperClass?: string,
  hasContactPerson?: boolean,
  url?: string,
  cta?: string
}

const Contact = ({
  title = 'contact.title',
  wrapperClass = 'xl:w-7/12 xl:ml-auto flex flex-col md:flex-row bg-top bg-repeat-x pt-12',
  url = 'contact.cta.url',
  cta = 'contact.cta',
  hasContactPerson = true,
}: ContactProps) => {
  const { t } = useTranslation();
  const { contactPerson } = useStaticQuery(imageQuery);

  return (
    <section className="py-12 px-4 lg:px-8 flex justify-end">
      <div className=" max-w-screen-2xl w-full mx-auto">
        <OpacityWrapper className={wrapperClass} style={{
          backgroundImage: 'linear-gradient(to right, #A38D70 40%, rgba(255, 255, 255, 0) 20%)',
          backgroundSize: '10px 1px'
        }}>
          <div className="md:w-5/12 pr-5">
            <FlyInText tag="h3" className="text-2xl lg:text-4xl font-cirka mb-8 w-2/3 lg:w-full">{t(title)}</FlyInText>
            <FlyInText>
              <Link to={t(url)} className="flex items-center text-primary font-light mt-3 no-animation">
                <ArrowButton isGhost={false} className="mr-3" />
                {t(cta)}
              </Link>
            </FlyInText>
          </div>
          <div className="md:w-7/12 mt-8 md:mt-0 md:ml-4">
            {hasContactPerson && (
              <div className="border border-primary p-8 flex h-auto">
                <GatsbyImage image={contactPerson && getImage(contactPerson)} alt={"contact person"} className="w-20 h-20 mr-8 flex-shrink-0" />
                <div>
                  <FlyInText tag="p" className="text-sm lg:text-base font-light mb-3" dangerouslySetInnerHTML={{ __html: t('contact.text') }} />
                  <FlyInText tag="div" className="flex items-center font-light mt-auto">
                    <Link to={t('contact.contactCta.url')} className="text-primary flex flex-row items-center text-sm lg:text-base">
                      <ArrowButton className="mr-3" />
                      {t('contact.contactCta')}
                    </Link>
                  </FlyInText>
                </div>
              </div>
            )}
          </div>
        </OpacityWrapper>
      </div>
    </section>
  );
}

export default Contact;
